import ApplicationAdapter from 'eflex/adapters/application';

export default class EdhrAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
